/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { UserCoinTransferInfo } from '@/api/types/user';

export interface StoreUserCoinMineState {
  loaded: boolean;
  balance: UserCoinTransferInfo['balance'];
  tax: UserCoinTransferInfo['tax'];
  wechatNick: string;
  tips: UserCoinTransferInfo['tips'];
  issues: UserCoinTransferInfo['issues'];
}

export default {
  namespaced: true,
  state: {
    loaded: false,
    balance: null,
    tax: null,
    wechatNick: null,
    tips: null,
    issues: null,
  },
  getters: {},
  actions: {
    [USER.GET_COIN_TRANSFER_INFO]({ state, commit }, { reload = false, refresh = false } = {}) {
      if (refresh ? state.loaded : reload || !state.loaded) {
        return new Promise((resolve, reject) => {
          api.getCoinTransferInfo().then((res) => {
            commit(USER.GET_COIN_TRANSFER_INFO, {
              data: res.data,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [USER.GET_COIN_TRANSFER_INFO](state, { data: { balance, tax, wechatNick, tips, issues } }) {
      state.balance = balance;
      state.tax = tax;
      state.wechatNick = wechatNick;
      state.tips = tips;
      state.issues = issues;
    },
  },
};
